/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  home: {
    intro: {
      title:
        'Un’Innovazione Cruciale per la Riabilitazione Facciale Basata sulla Realtà Aumentata',
      text: 'Il MEPP è uno strumento innovativo di riabilitazione facciale, destinato a trattare la paralisi facciale. Nato da ricerche collaborative del Quebec, riunisce ricercatori, pazienti, clinici, tecnologi e studenti per migliorare la qualità della vita delle persone affette da paralisi facciale. Il MEPP utilizza la realtà aumentata e si basa su dati probatori per rendere la riabilitazione facciale più accessibile.',
      financialTitle: 'Con il supporto finanziario di:',
    },
    description: {
      title: 'La terapia dello specchio nella riabilitazione facciale',
      text: 'Il MEPP è accompagnato da un’applicazione per dispositivi mobili. Permette a un/una terapeuta di offrire terapia speculare nella riabilitazione del viso, per pazienti/e affetti/e da paralisi facciale. Il MEPP offre una piattaforma ai clinici/e per gestire una base di esercizi, produrre piani di esercizi personalizzati e aggiungere più utenti. Inoltre, il sito offre uno spazio virtuale personalizzato che consente alle persone che necessitano di riabilitazione di eseguire i propri esercizi.',
      list: {
        title:
          'Sono stati condotti diversi studi per testare l’usabilità e l’efficacia del MEPP:',
        loading: 'Caricamento in corso…',
        error: 'Si è verificato un errore durante il caricamento!',
      },
    },
    history: {
      title:
        'Circa <span style="color:#008EDE;">15,4 milioni</span> di persone all’anno nel mondo avranno una paralisi facciale, causata dalla paralisi di Bell o da un ictus.',
      text1:
        'Circa 15,4 milioni (M) di persone all’anno nel mondo soffriranno di paralisi facciale, causata dalla paralisi di Bell o da un ictus (Feigin et al, 2022). Questo rappresenta ≈110.000 e ≈23.000 persone ogni anno in Canada e in Québec. Per queste persone, la riabilitazione è quindi essenziale per favorire il recupero delle funzioni e per migliorare la loro qualità della vita. La riabilitazione avviene grazie al lavoro congiunto dei pazienti con i professionisti della salute, specializzati nella valutazione e nella riabilitazione della paralisi facciale. Tuttavia, per questi professionisti, attualmente sono disponibili molto pochi strumenti specializzati e basati su evidenze. Dobbiamo quindi principalmente lavorare esplorando, a tentoni, una letteratura abbondante e disparata, il che ostacola l’efficacia delle loro interventi e può portare a risultati clinici inferiori.',
      text2:
        'Per affrontare questa importante problematica, il team di ricerca composto dalla dottoressa Sarah Martineau, logopedista e professoressa associata clinica all’Università di Montréal, dalla dottoressa Karine Marcotte, logopedista e ricercatrice, e dal dottor Akram Rahal, ORL e professore clinico all’Università di Montréal, ha sviluppato il Mirror Effect Plus Protocol (MEPP) tra il 2017 e il 2023. Questa riabilitazione, e il sito web ad essa associato, si basa sui principi di intervento importanti nella paralisi facciale, così come sulla terapia dello specchio. Il sito integra una progressione degli esercizi e un aiuto visivo per facilitare la riabilitazione delle persone con danni neurologici al volto. Il MEPP propone un approccio personalizzato alla duplicazione del volto, unico rispetto ai software di riabilitazione facciale disponibili sul mercato. Inoltre, i protocolli di riabilitazione e gli esercizi integrati nel sito si basano sulle più recenti evidenze scientifiche. Questo strumento facilita quindi notevolmente il lavoro dei professionisti e il processo terapeutico dei pazienti, poiché offre una struttura chiara, basata sulla letteratura scientifica, facilitando nel contempo l’accessibilità agli esercizi a casa e la tele-riabilitazione nel campo della paralisi facciale.',
      persons: {
        person1: {
          name: 'Dott.ssa Sarah Martineau',
          title:
            'Logopedista e professoressa associata di clinica all’Università di Montreal',
        },
        person2: {
          name: 'Dott.ssa Karine Marcotte',
          title: 'Logopedista e ricercatrice',
        },
        person3: {
          name: 'Dott. Akram Rahal',
          title: 'ORL e professore clinico all’Università di Montréal',
        },
      },
    },
    donate: {
      title: 'Aiutaci a fare in modo che il MEPP sia accessibile a tutti.',
      text: 'Tutte le donazioni supportano direttamente lo sviluppo del MEPP, affinché possiamo fornire accesso gratuito ai nostri strumenti a chi ne ha più bisogno. Fai una donazione oggi stesso.',
    },
  },
};
